import { render, staticRenderFns } from "./Accessories.vue?vue&type=template&id=55856440"
import script from "./Accessories.vue?vue&type=script&lang=ts"
export * from "./Accessories.vue?vue&type=script&lang=ts"
import style0 from "./Accessories.vue?vue&type=style&index=0&id=55856440&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports